import { render, staticRenderFns } from "./LottoForecastView.vue?vue&type=template&id=2c3fe6c6&scoped=true&lang=pug"
import script from "./LottoForecastView.vue?vue&type=script&lang=js"
export * from "./LottoForecastView.vue?vue&type=script&lang=js"
import style0 from "./LottoForecastView.vue?vue&type=style&index=0&id=2c3fe6c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3fe6c6",
  null
  
)

export default component.exports